<template>
  <iframe style="width: 100%; height: 100%; position: absolute; inset: 0; border-width: 0px"
          :src="url"></iframe>
</template>

<script>
import {default as ModuleFunctionApi} from "@/api/smp/sys/ModuleFunctionApi";
import { default as SmploginApi } from "@/api/smp/smplogin/Smplogin";

export default {
  name: "FineReport",
  props: {
    page: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      url:'',
      webpageType:'',
    }
  },
  computed: {
    session() {
      let session = this.$store.getters['app/getSession'];
      if (!session)
        session = {userId: ''};
      return session;
    }
  },
  mounted() {
    console.log(this.page)
    this.getModuleFun();
  },
  methods:{
    getModuleFun(){
      let me = this;
      ModuleFunctionApi.queryMenuUiFunction(this.page.id).then(function(resp){
        let data = resp.data;
        if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
          let msg=data.msg;
          msg = ((!msg)||(msg==''))?'获取连带功能信息失败':msg;
          throw new Error(msg);
          return;
        }

        let moduleFunctions = data.data.moduleFunctions;
        console.log("request menuRelateFunction returned:");
        console.log(moduleFunctions);
        let moduleFunc = moduleFunctions[0];
        me.webpageType = moduleFunc.webpageTypeId;
        if(moduleFunc.webpageTypeId == 1){//帆软
          me.url = moduleFunc.path + "&menu_id=0&FROM_APP_ID=2&PERSON_ID=" + me.session.userId;
        }
		else if(moduleFunc.webpageTypeId == 3){//单点登录应用
		  me.smpLogin(moduleFunc.path)
		}
		else if(moduleFunc.webpageTypeId == 4){//商友
		  me.smpLogin(moduleFunc.path)
		}
		else{
          me.url = moduleFunc.path;
        }
      }).catch(function(err){
        console.log(err);
        me.errMsg('错误','获取连带功能信息失败:'+err.message);
      });
    },
    async  errMsg(title,text){
      await this.$dialog.error({
        text: text,
        title: title
      });
    },
	smpLogin(path){
		let me = this
		SmploginApi.smplogin().then(function(res){
			console.log(res)
			let url='';
			if(path.indexOf('?')==-1){
				url = path+"?smpLoginToken="+res.data.msg
			}else{
				url = path+"&smpLoginToken="+res.data.msg
			}
			console.log(url)
			console.log("单点跳转链接",res.data.msg)
			me.url = url
		})
	}
  }
}
</script>

<style scoped>

</style>